import { useTranslation } from 'react-i18next';
import { Grid } from '@shared/ui';

import { SectionHeader } from './SectionHeader';
import { IconsShowcase } from './icons/IconsShowcase';

export function IconsSection() {
  const { t } = useTranslation();

  return (
    <section id="icons" className="space-y-6">
      <SectionHeader
        title={t('uiLibrary.icons.title')}
        description={t('uiLibrary.icons.description')}
      />

      <Grid cols={1} gap="lg" className="lg:grid-cols-2">
        <IconsShowcase />
      </Grid>
    </section>
  );
}
